/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_MANAGE_HIGH_VALUE_LEAD,
  LOAD_MANAGE_HIGH_VALUE_LEAD_SUCCESS,
  LOAD_MANAGE_HIGH_VALUE_LEAD_ERROR,

  ADD_FOLLOWUP,
  ADD_FOLLOWUP_SUCCESS,
  ADD_FOLLOWUP_ERROR,

  UPDATE_SUBSTATUS,
  UPDATE_SUBSTATUS_SUCCESS,
  UPDATE_SUBSTATUS_ERROR,

  UPDATE_REJECT,
  UPDATE_REJECT_SUCCESS,
  UPDATE_REJECT_ERROR,

  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR,
  
  UPLOAD_FOLLOW_ATTACHMENT_RECORD,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


//permission list
export function loadManageHighValueLead(searchvalue) {
  return {
    type: LOAD_MANAGE_HIGH_VALUE_LEAD,
    searchvalue,
  }
}
export function loadManageHighValueLeadSuccess(manageHighValueLead_details) {
  return {
    type: LOAD_MANAGE_HIGH_VALUE_LEAD_SUCCESS,
    manageHighValueLead_details,
  }
}
export function loadManageHighValueLeadError(error) {
  return {
    type: LOAD_MANAGE_HIGH_VALUE_LEAD_ERROR,
    error,
  }
}

export function addFollowUp(followupValues) {
  return {
    type:ADD_FOLLOWUP,
    followupValues,
  }
}
export function addFollowUpSuccess() {
  return {
    type: ADD_FOLLOWUP_SUCCESS,
    
  }
}
export function addFollowUpError(error) {
  return {
    type: ADD_FOLLOWUP_ERROR,
    error,
  }
}

export function updateSubStatus(subStatusValues) {
  return {
    type:UPDATE_SUBSTATUS,
    subStatusValues,
  }
}
export function updateSubStatusSuccess() {
  return {
    type: UPDATE_SUBSTATUS_SUCCESS,
    
  }
}
export function updateSubStatusError(error) {
  return {
    type: UPDATE_SUBSTATUS_ERROR,
    error,
  }
}

export function updateReject(rejectValues) {
  return {
    type:UPDATE_REJECT,
    rejectValues,
  }
}
export function updateRejectSuccess() {
  return {
    type: UPDATE_REJECT_SUCCESS,
    
  }
}
export function updateRejectError(error) {
  return {
    type: UPDATE_REJECT_ERROR,
    error,
  }
}


export function loadRecordsAttachmentDetailData(searchValue) {
  console.log(searchValue,"payload checking")
  return {
    type: LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD,
     searchValue
  }
}

export function loadRecordsAttachmentDetailDataSuccess(attachmentRecord) {
  return {
    type: LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS,
    attachmentRecord,
  }
}

export function loadRecordsAttachmentDetailDataError(error) {
  return {
    type: LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR,
    error,
  }
}


// Upload Attachment
export function uploadFollowupAttachmentRecordData(uploadRecord) {
  return {
    type: UPLOAD_FOLLOW_ATTACHMENT_RECORD,
    uploadRecord,
  }
}

export function uploadFollowupAttachmentRecordDataSuccess(uploadRecord) {
  return {
    type: UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
    uploadRecord,
  }
}

export function uploadFollowupAttachmentRecordDataError(error) {
  return {
    type: UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadManageHighValueLead,
  loadManageHighValueLeadSuccess,
  loadManageHighValueLeadError,

  addFollowUp,
  addFollowUpSuccess,
  addFollowUpError,

  updateSubStatus,
  updateSubStatusSuccess,
  updateSubStatusError,

  updateReject,
  updateRejectSuccess,
  updateRejectError,

  
  uploadFollowupAttachmentRecordData,
  uploadFollowupAttachmentRecordDataSuccess,
  uploadFollowupAttachmentRecordDataError,

  loadRecordsAttachmentDetailData,
  loadRecordsAttachmentDetailDataSuccess,
  loadRecordsAttachmentDetailDataError,


}

export default actions
